import type { ConnectedProjectDto, ProjectOverviewItemDto } from "@/api/types";

export function hasFilterableProjects(projects: (ConnectedProjectDto | ProjectOverviewItemDto)[]): boolean {
  if (projects.length < 2) {
    return false;
  }

  const owners = new Set<string>();
  const maintenances = new Set<string>();
  const cities = new Set<string>();

  for (const p of projects) {
    owners.add(p.owner);
    if (owners.size > 1) {
      return true;
    }

    maintenances.add(p.maintenance);
    if (maintenances.size > 1) {
      return true;
    }

    cities.add(p.city);
    if (cities.size > 1) {
      return true;
    }
  }

  return false;
}
